/**
 * View video block.
 * @module components/manage/Blocks/Video/View
 */

import PropTypes from 'prop-types';
import Body from '@plone/volto/components/manage/Blocks/Video/Body';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import { Media } from '@designsystem/stories/02-atoms/Media';

/**
 * View video block class.
 * @class View
 * @extends Component
 */
const View = (props) => {
  const { data, className } = props;
  const { format, caption, autoplay, hide_controls, force_captions, ...rest } =
    data;
  return (
    <Media
      aspect={format}
      caption={caption}
      className={`${className} media--video media--align-${data?.align} media--size-${data?.size}${data?.float ? ' media--float' : ''}`}
    >
      <div className="media__object media__object--embed">
        <Body
          data={rest}
          autoplay={!!autoplay}
          controls={!hide_controls}
          forceCaptions={!!force_captions}
        />
      </div>
    </Media>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withBlockExtensions(View);
